






import { Component } from 'vue-property-decorator';
import AbstractDisplayField from '../abstract-display-field/abstract-display-field';
import { mixins } from 'vue-class-component';

@Component({
  name: 'bpc-display-field-score',
  components: {},
})
export default class DisplayFieldScore extends mixins(AbstractDisplayField) {
  get variant(): string {
    if (this.value === 'cancelled') {
      return 'danger';
    }

    const scores = this.value.split(' - ');

    if (scores[0] !== '' && scores[0] === scores[1]) {
      return 'warning';
    }

    if ((this.item?.away && scores[0] > scores[1]) || (!this.item?.away && scores[0] < scores[1])) {
      return 'danger';
    } else if (
      (this.item?.away && scores[0] < scores[1]) ||
      (!this.item?.away && scores[0] > scores[1])
    ) {
      return 'success';
    }

    return 'info';
  }

  get score() {
    if (this.value === 'cancelled') {
      return 'global.fields.status.cancelled.label';
    } else {
      return this.value;
    }
  }
}
